import React from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'redux-form';
import { OfficesSelectBox } from 'src/jbc-front/components/SearchForm';
import jbcStyles from 'jbc-front/components/SearchForm.scss';
import { useTranslation } from 'react-i18next';
import { getSelectOptions } from 'src/reducers/selectOptions';
import YearPickerField from './YearPickerField';

const getOffices = state => getSelectOptions(state, 'offices') || [];

const IncomeTaxDeclarationAdditionalSearchFields = () => {
  const { t } = useTranslation();
  const offices = useSelector(getOffices);

  return (
    <div className={jbcStyles.details}>
      <div className={jbcStyles.detailsRow}>
        <div className={jbcStyles.detailsHeader}>{t('features.ReportIncomeTax.list.search.office')}</div>
        <div className={jbcStyles.detailsBody}>
          <div className={jbcStyles.detailsBodyItems}>
            <Field name="offices" component={OfficesSelectBox} options={offices} />
          </div>
        </div>
      </div>

      <div className={jbcStyles.detailsRow}>
        <div className={jbcStyles.detailsHeader}>{t('features.ReportIncomeTax.list.search.tax_period')}</div>
        <div className={jbcStyles.detailsBody}>
          <div className={jbcStyles.detailsBodyItems}>
            <Field name="year" component={YearPickerField} placeholder={t('features.ReportIncomeTax.list.search.select_year')} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncomeTaxDeclarationAdditionalSearchFields;
